export default {
    
  settingsDriver_search: "Buscar por conductor, Código o Supervisor",
  settingsDriver_driver: "Nombre del conductor",
  settingsDriver_name: "Nombre",
  settingsDriver_licenseNumber: "Número de licencia",
  settingsDriver_registrationState: "Estado de registro",
  settingsDriver_registrationCountry: "Pais de registro",
  settingsDriver_driverPin: "Número de PIN",
  settingsDriver_email: "Correo",
  settingsDriver_notifyByEmail: "¿Quieres recibir notificaciones por correo?",
  settingsDriver_notifyBySms: "¿Quieres recibir notificaciones por SMS?",
  settingsDriver_indicator: "Indicador",
  settingsDriver_phone: "Teléfono",
  settingsDriver_phoneNumber: "Número de teléfono",
  settingsDriver_vehicle: "Vehiculo",
  settingsDriver_timezone: "Zona horaria",
  settingsDriver_contact: "Contacto",
  settingsDriver_zonarELD: "Horas de servicio",
  settingsDriver_zonarELDExempt: "Horas de servicio Exento",
  settingsDriver_contactDetails: "Detalles de contacto",
  settingsDriver_supervisor: "Supervisor",
  settingsDriver_supervisorPlaceHolder: "Seleccione un Supervisor",
  settingsDriver_cellphone: "Celular",
  settingsDriver_carrier: "Portador",
  settingsDriver_address: "Correo",
  settingsDriver_username: "Nombre de Usuario",
  settingsDriver_password: "Contraseña",
  settingsDriver_repeatPassword: "Repetir contraseña",
  settingsDriver_repeatPasswordDoNotMatch: "Las contraseñas no coinciden",
  settingsDriver_defaultTab: "Tab por defecto",
  settingsDriver_create: "Crear nuevo Conductor",
  settingsDriver_edit: "Editar Conductor",
  settingsDriver_delete: "Eliminar Conductor",
  settingsDriver_created: "Conductor fue creado exitosamente",
  settingsDriver_updated: "Conductor fue actualizado exitosamente",
  settingsDriver_deleted: "Conductor fue eliminado exitosamente",
  settingsDriver_fsmLogin: "Usuario de la Aplicación",
  settingsDriver_supervisor: "Supervisor",
  settingsDriver_addFsmLogin: "Editar para crear",
  settingsDriver_minLengthMessageName: "El nombre de usuario debe contener un mínimo de caracteres:",
  settingsDriver_maxLengthMessageName: "El nombre de usuario debe contener un máximo de caracteres:",
  settingsDriver_exactLengthMessagePin: "El PIN debe contener exactamente 4 dígitos:",
  settingsDriver_minLengthMessagePassword: "La contraseña debe contener un mínimo de caracteres:",
  settingsDriver_maxLengthMessagePassword: "La contraseña debe contener un máximo de caracteres:",
  settingsDriver_maxLengthMessageCellPhone: "El teléfono celular debe contener un máximo de caracteres:",
  settingsDriver_minLengthMessageCellPhone: "El teléfono celular debe contener un mínimo de caracteres:",
  settingsDriver_addressMessage: "El correo es incorrecto.",
  settingsDriver_descriptonDelete: "¿Está seguro de que desea eliminar los Conductores?",
  settingsDriver_fmsLoginMessage: "Para crear o editar el inicio de sesión de Ignition Driver App, es necesario agregar los dos campos siguientes:",
  settingsDriver_fmsLoginPwdRequired: 'La contraseña es requerida',
  settingsDriver_hasVideoAccess: 'Tiene Acceso a Videos',
  settingsDriver_import:"Importar conductores",
  settingsDriver_descriptonImport:"Importar conductores por archivo csv",
  settingsDriver_import_driver:"Importar Conductores",
  settingsDriver_delimiter:"Delimitador",
  settingsDriver_file:"Archivo",
  settingsDriver_upload:"Cargar",
  settingsDriver_error_delimiter:"Error en el archivo, por favor confirma el delimitador",
  settingsDriver_error_name_required:"El nombre del conductor, el grupo y el Email son requeridos",
  settingsDriver_error_name_repeat:"El nombre del conductor o el Email estan repetidos",
  settingsDriver_error_name_repeat_file:"El nombre del conductor ya existe",
  settingsDriver_error_fix:"Por favor corregir los errores antes de continuar",
  settingsDriver_error_started:"La importacion se inicio correctamente,en un momento te indicaremos cuando termine",
  settingsDriver_error_required:"El archivo csv es requerido",
  settingsDriver_template:"Formato csv",
  settingsDriver_aceept_file:"Solo se aceptan archivos csv",
  settingsDriver_email: 'Email',
  settingsDriver_group: 'Etiqueta',
  settingsDriver_error: 'Error',
  settingsDriver_semicolon: 'Punto y coma',
  settingsDriver_comma: 'Coma',
  settingsDriver_resume:'Resumen de la transaccion',
  settingsDriver_importation_title:'Importacion terminada',
  settingsDriver_importation_body:'Para visualizar el resumen presione click en la notificacion',
  settingsDriver_status:'Estado',
  settingsDriver_tag:'Etiqueta',
  settingsDriver_employeeNumber:'Número de empleado',
  settingsDriver_licenseExpDate: "Fecha de vencimiento de la licencia",
  settingsDriver_id: "ID",
  settingsDriver_driverPin: "Número de PIN",
  settingsDriver_licenseNumber: "Número de licencia",
  settingsDriver_licenseCountry: "País de registro",
  settingsDriver_licenseState: "Estado de registro",
  settingsDriver_timezone: "Zona horaria",
  settingsDriver_hosRuleSet: "Horas de servicio",
  settingsDriver_hosExempt: "Horas de servicio Exento",
  settingsDriver_hosExemptComment: "Comentario Exento",
  settingsDriver_personalConveyance: "Conducción personal",
  settingsDriver_allowedPCDistance: "Distancia permitida de PC",
  settingsDriver_personalYardMoves: "Movimientos de patio",

  settingsDriver_select_delimiter: "Seleccionar",
  drivers_import_instructions: 'Nota Importante: La columna ID es obligatoria. Si el proceso de importación está destinado a actualizar registros existentes, realice una exportación de tabla sin editar el valor de la columna ID para mantener la referencia del registro. Si desea crear nuevos conductores, deje la columna ID en blanco.',
  drivers_download_template: 'Descargar Plantilla',

  settingsDriver_filterBy:'Filtrar por',
  settingsDriver_clearFilters:'Limpiar filtros',

  settingsDriver_all: "Todo",
  settingsDriver_tags: "Etiquetas",
  settingsDriver_units: "Unidades",
  settingsDriver_unassigned: "Sin etiquetar",
  settingsDriver_drivers: "Conductores",
  settingsDriver_driversFaces: "Caras de conductores",
  settingsDriver_driversFacesAssign: "Asignar Conductor",
  settingsDriver_driversFacesAll: "Todos",
  settingsDriver_driversFacesLinked: "Vinculadas",
  settingsDriver_driversFacesUnlinked: "No vinculadas",
  settingsDriver_driversFacesAssignedTo: "Asignado A",
  settingsDriver_driversFacesNoVh: "Vehiculo no Asignado",
  settingsDriver_driversFacesDetele: 'Eliminar este rostro',
  settingsDriver_driversFacesSelectTempUrl: 'seleccionar esta imagen como avatar temporal',
  settingsDriver_driversFacesSelectDriver: "Asignar estas caras al conductor:",
  settingsDriver_driversFacesCleanSeleted: "Limpiar los elementos seleccionados",
  settingsDriver_driversFacesUpdateSuccess: "las imágenes seleccionadas fueron asignadas correctamente al conductor seleccionado",
  settingsDriver_driversFacesUpdateError: "Ocurrio un error asignando la imagenes",
  settingsDriver_driversFacesdeleteCollection: "¿Esta seguro que desea eliminar estas colecciones de conductores?",
  settingsDriver_driversFacesDeleteCollectionSuccess: "la coleccion de conductores fue eliminada correctamente",
  settingsDriver_driversFacesDeleteCollectionError: "ocurrio un error eliminando la coleccion de drivers",
  settingsDriver_driversFacesDeleteCollectionTitle: "Eliminar coleccion de conductor",
  settingsDriver_driversFacesdeleteFaceId: "¿Estás seguro de que quieres eliminar esta cara de esta coleccion? Esta acción no se puede deshacer.",
  settingsDriver_driversFacesdeleteFaceIdTitle: "Eliminar esta cara de esta coleccion",
  settingsDriver_driversFacesNoFaceDetected: "Esta coleccion no tiene imagenes",


  settingsDriver_driversTagDelete: "Remover Conductores de las Etiquetas",
  settingsDriver_descriptonDriversTagDelete: "¿Está seguro de que desea remover los conductores de las siguientes etiquetas?",
  settingsDriver_deletedDriversTag: "Los conductores se eliminaron de las etiquetas con éxito",
  settingsDriver_searchTags: "Buscar por etiqueta",
  settingsDriver_avatar: "Foto Perfil",
  settingsDriver_timeCard: "Tarjeta de tiempo",
  settingsDriver_changeStatus: "Cambiar Estado",
  settingsDriver_successChangeStatus: "El estado ha sido cambiado.",
  settingsDriver_change: "Cambiar",

  settingsDriver_externalId: "Código",
  settingsDriver_error_externalID_repeat:"El Código del conductor está repetido",
  settingsDriver_error_externalID_long: "El Código del conductor debe tener máximo 10 caracteres",
  settingsDriver_error_externalID: "El Código del conductor debe contener solo números y letras",
  settingsDriver_error_duplicated: "Ya existe un conductor con los datos de contacto, Código o nombre ingresados",
  settingsDriver_codeDuplicated: "Código duplicado",
  settingsDriver_error_username_duplicated: "Ya existe un conductor con el nombre de usuario ingresado",
  settingsDriver_error_invalid_name: "El nombre del conductor no es válido, elimine los números y caracteres especiales",

  settingsDriver_yes: "Si  ",
  settingsDriver_no: "No  ",

  settingsDriver_invalidEmail: "El correo electrónico no es válido, por favor ingrese un correo electrónico válido",
  settingsDriver_resetPassword: "Restablecer credenciales",
  settingsDriver_invalidUsername: "El nombre de usuario no es válido, por favor ingrese un nombre de usuario válido",
  settingsDriver_invalidPassword: "La contraseña no es válida, por favor ingrese una contraseña válida",
  settingsDriver_resetPasswordSuccess: "La contraseña ha sido restablecida con éxito",
  settingsDriver_errorMessageDeleteDriver: "No es posible eliminar conductores que tengan pedidos de servicio activos asignados, por favor cancele los pedidos de servicio antes de eliminar los conductores",
  settingsDriver_errorMessageCreateDriver: "Detalles de contacto, Código, Nombre o KeyFob duplicados, por favor verifique la información ingresada",
  settingsDriver_avatar: "Avatar",
  settingsDriver_workOrderError: "No es posible inactivar el conductor porque tiene pedidos de servicio activos asignados",
  settingsDriver_usernameError: "El nombre de usuario para el conductor está duplicado.",
  settingsDriver_usernameErrorLength: "El nombre de usuario debe contener entre 4 y 12 caracteres",
  settingsDriver_invalidDriverPin: "El número de PIN del conductor debe contener solo números",
  settingsDriver_invalidLicenseNumber: "El número de licencia debe contener solo números",
  settingsDriver_licenseNumberError: "El número de licencia está duplicado",
  settingsDriver_driverPinError: "El número de PIN del conductor debe ser un número positivo",
  settingsDriver_zonarELDExemptComment: "Comentario Exento",
  settingsDriver_zonarELDExemptCommentError: "Si el conductor está exento de las reglas de HOS, se requiere un comentario exento",
  settingsDriver_keyFobHex: "KeyFob",
  settingsDriver_keyFobHexError: "El key fob está duplicado",
  settingsDriver_keyFobAlreadyAssigned: "El Key Fob ya está asignado a un conductor",
  settingsDriver_companyReadonly: "La compañía es de solo lectura",
  settingsDriver_nameMinLength: "El nombre debe contener mínimo 2 caracteres",
  settingsDriver_invalidContactInfo: "Información de contacto inválida",
  settingsDriver_usernameNoSpaces: "El nombre de usuario no debe tener espacios.",
  settingsDriver_passwordMinLength: "La contraseña debe contener mínimo 6 caracteres",
  settingsDriver_unitForbidden: "Prohibido, no tienes acceso a esta unidad",
  settingsDriver_driverForbidden: "Prohibido, no tienes acceso a este conductor",
  settingsDriver_timezoneNotFound: "La zona horaria no existe.",
  settingsDriver_allowedPCDistanceMinError: "La distancia permitida de PC debe ser al menos 5 millas (8 km)",
  settingsDriver_allowedPCDistanceMaxError: "La distancia permitida de PC no debe exceder 1608 km (1000 millas)",
  settingsDriver_eldRequiredFields: "requerido(s) para cuentas con ELD habilitado.",
  settingsDriver_eldRequiredAnd: "y",
  settingsDriver_eldRequiredIs: "es",
  settingsDriver_eldRequiredAre: "son",

  settingsDriver_invalidUsernameLength: "El nombre de usuario debe contener un mínimo de 4 caracteres y un máximo de 12 caracteres",
  
  settingsDriver_passwordRequired: "Si deseas crear un nuevo nombre de usuario, la contraseña es requerida",
  settingsDriver_passwordRequiredToCreateOrEdit: "La contraseña es requerida",
  settingsDriver_email_already_exists: "El correo electrónico ya existe",
  settingsDriver_minLengthMessageLicenseNumber: "El número de licencia debe contener un mínimo de 7 caracteres",
  settingsDriver_minLengthMessageExternalId: "El código debe contener un mínimo de 3 caracteres",
  settingsDriver_externalIdDigitsOnly: "El código debe contener solo números",
  settingsDriver_minLengthMessageEmployeeNumber: "El número de empleado debe contener un mínimo de 12 caracteres",
  settingsDriver_specialDutyStatuses: 'Estados de servicio especial:',
  settingsDriver_personalConveyance: 'Conducción personal',
  settingsDriver_personalYardMoves: 'Movimientos de patio',
  settingsDriver_allowedPCDistance: 'Distancia permitida de PC',
  settingsDriver_allowedPCDistanceError: 'La distancia permitida de PC debe ser mayor a',

  // Import error codes translations (from backend)
  drivers_import_error_D001: 'Campo requerido faltante: Código',
  drivers_import_error_D002: 'Campo requerido faltante: Nombre del Conductor',
  drivers_import_error_D003: 'Campo requerido faltante: Número de Empleado',
  drivers_import_error_D004: 'Campo requerido faltante: Número PIN',
  drivers_import_error_D005: 'Campo requerido faltante: Número de Licencia',
  drivers_import_error_D006: 'Campo requerido faltante: País de Registro',
  drivers_import_error_D007: 'Campo requerido faltante: Estado de Registro',
  drivers_import_error_D008: 'Campo requerido faltante: Zona Horaria',
  drivers_import_error_D009: 'Campo requerido faltante: Etiquetas',
  drivers_import_error_D010: 'Campo requerido faltante: KeyFob',
  drivers_import_error_D011: 'Campo requerido faltante: Conjunto de Reglas de Horas de Servicio (requerido cuando Zonar ELD está habilitado)',
  drivers_import_error_D012: 'Ocurrió un error de procesamiento',
  drivers_import_error_D020: 'El Código excede la longitud máxima de 40 caracteres',
  drivers_import_error_D021: 'El Nombre del Conductor excede la longitud máxima de 100 caracteres',
  drivers_import_error_D022: 'El Número de Empleado excede la longitud máxima de 20 caracteres',
  drivers_import_error_D023: 'El Número PIN excede la longitud máxima de 4 caracteres',
  drivers_import_error_D024: 'El Número de Licencia excede la longitud máxima de 15 caracteres',
  drivers_import_error_D025: 'El KeyFob excede la longitud máxima de 20 caracteres',
  drivers_import_error_D026: 'El Email excede la longitud máxima de 50 caracteres',
  drivers_import_error_D027: 'El Número de Teléfono excede la longitud máxima de 10 caracteres',
  drivers_import_error_D030: 'Formato de Fecha de Expiración de Licencia inválido',
  drivers_import_error_D031: 'Formato de email inválido',
  drivers_import_error_D032: 'El Número de Teléfono debe contener solo dígitos',
  drivers_import_error_D033: 'La Distancia PC Permitida debe ser un número válido',
  drivers_import_error_D037: 'La distancia PC permitida no debe exceder 1608 km (1000 millas)',
  drivers_import_error_D040: 'Etiquetas no encontradas',
  drivers_import_error_D041: 'Sin permiso para las etiquetas',
  drivers_import_error_D042: 'Conductor con ID no encontrado',
  drivers_import_error_D043: 'El nombre del conductor ya existe (duplicado)',
  drivers_import_error_D047: 'El código ya existe (duplicado)',
  drivers_import_error_D050: 'Error al crear conductor',
  drivers_import_error_D051: 'Error al actualizar conductor',
  drivers_import_error_D052: 'El Comentario Exento debe estar vacío cuando Horas de Servicio Exento es No',
  drivers_import_error_D053: 'No se detectaron cambios para el conductor.',
  drivers_import_partial_success: 'Importación completada con algunos errores. Revise el resumen de la transacción.',
  drivers_import_failed: 'La importación falló. Por favor revise el archivo e intente nuevamente.',
  drivers_import_cancel: 'Cancelar',
  drivers_import_button: 'Importar',
};  